import { OrbindApiError } from '@orbind/api-client'

/**
 * Que tipo de "deu errado" foi este — a decisão, sem React nem UI junto.
 *
 * Mora fora do componente porque é a única parte testável: importar o
 * componente arrastaria o @orbind/ui para dentro do teste, que roda fora do
 * navegador (mesmo motivo de `favicon.ts` na API e `portas-de-entrada.ts` no
 * Item de Trabalho).
 */

/**
 * SEM PERMISSÃO é 403; 404 de canal entra junto de propósito.
 *
 * O servidor responde 404 para canal que existe mas não é seu — é o certo,
 * porque dizer "403" já contaria que aquele canal existe. Para quem olha a
 * tela, os dois casos são a mesma coisa: não é para você. O que não pode é
 * cair no estado vazio, que afirma que a conversa está limpa.
 */
export function ehSemPermissao(erro: unknown): boolean {
  return erro instanceof OrbindApiError && (erro.status === 403 || erro.status === 404)
}

/** A mensagem do servidor, quando houver — ela costuma ser mais específica. */
export function mensagemDoServidor(erro: unknown): string {
  return erro instanceof OrbindApiError ? erro.message : ''
}
